"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
const defaultTheme = require("tailwindcss/defaultTheme");
exports.default = {
  theme: {
    extend: {
      keyframes: {
        fadeIn: {
          '0%': {
            opacity: '0'
          },
          '100%': {
            opacity: '1'
          }
        },
        fadeOut: {
          '0%': {
            opacity: '1'
          },
          '100%': {
            opacity: '0'
          }
        },
        swipeLeftFull: {
          '0%': {
            transform: 'translateX(0)',
            opacity: '1'
          },
          '100%': {
            transform: 'translateX(-100%)',
            opacity: '0'
          }
        },
        slideUpSm: {
          '0%': {
            transform: 'translateY(50px)',
            opacity: '0'
          },
          '100%': {
            transform: 'translateY(0)',
            opacity: '1'
          }
        },
        slideUpFull: {
          '0%': {
            transform: 'translateY(100%)',
            opacity: '0'
          },
          '100%': {
            transform: 'translateY(0)',
            opacity: '1'
          }
        },
        slideDownFull: {
          '0%': {
            transform: 'translateY(0)',
            opacity: '1'
          },
          '100%': {
            transform: 'translateY(100%)',
            opacity: '0'
          }
        },
        dissolve: {
          '100%': {
            opacity: '0'
          }
        }
      },
      // Naming convention for custom animation classes:
      // <action>-<direction?>-<distance?>-<duration>
      animation: {
        'slide-up-sm-100': 'slideUpSm 100ms ease-out',
        'slide-up-full-300': 'slideUpFull 300ms ease-out',
        'slide-down-full-300': 'slideDownFull 300ms ease-out',
        'dissolve-100': 'dissolve 100ms ease-out',
        'swipe-left-300': 'swipeLeftFull 300ms ease-out',
        'fade-in-300': 'fadeIn 300ms ease-out',
        'fade-out-300': 'fadeOut 300ms ease-out'
      }
    },
    colors: {
      neutral: {
        '50': '#fafafa',
        '100': '#f5f5f5',
        '200': '#e5e5e5',
        '300': '#d4d4d4',
        '400': '#a3a3a3',
        '500': '#737373',
        '600': '#525252',
        '700': '#404040',
        '800': '#262626',
        '900': '#171717',
        '950': '#0a0a0a',
        black: '#000000',
        white: '#ffffff'
      },
      primary: {
        '25': '#f9fffe',
        '50': '#f3faf9',
        '100': '#d8efec',
        '200': '#b0dfda',
        '300': '#81c7bf',
        '400': '#57aaa1',
        '500': '#3d8f86',
        '600': '#2f726b',
        '700': '#295c56',
        '800': '#244b47',
        '900': '#223f3c',
        '950': '#0f2422'
      },
      secondary: {
        '25': '#fffaf6',
        '50': '#fdf5ef',
        '100': '#fae8da',
        '200': '#f4cdb4',
        '300': '#edac84',
        '400': '#e48053',
        '500': '#e06b3f',
        '600': '#cf4927',
        '700': '#ac3722',
        '800': '#8a2e22',
        '900': '#6f281f',
        '950': '#3c120e'
      },
      utility: {
        green: {
          '50': '#f0fdf4',
          '100': '#dcfce7',
          '200': '#bbf7d0',
          '300': '#86efac',
          '400': '#4ade80',
          '500': '#22c55e',
          '600': '#16a34a',
          '700': '#15803d',
          '800': '#166534',
          '900': '#14532d',
          '950': '#052e16'
        },
        red: {
          '50': '#fef2f2',
          '100': '#fee2e2',
          '200': '#fecaca',
          '300': '#fca5a5',
          '400': '#f87171',
          '500': '#ef4444',
          '600': '#dc2626',
          '700': '#b91c1c',
          '800': '#991b1b',
          '900': '#7f1d1d',
          '950': '#450a0a'
        },
        orange: {
          '50': '#fff7ed',
          '100': '#ffedd5',
          '200': '#fed7aa',
          '300': '#fdba74',
          '400': '#fb923c',
          '500': '#f97316',
          '600': '#ea580c',
          '700': '#c2410c',
          '800': '#9a3412',
          '900': '#7c2d12',
          '950': '#431407'
        },
        blue: {
          '50': '#eff6ff',
          '100': '#dbeafe',
          '200': '#bfdbfe',
          '300': '#93c5fd',
          '400': '#60a5fa',
          '500': '#3b82f6',
          '600': '#2563eb',
          '700': '#1d4ed8',
          '800': '#1e40af',
          '900': '#1e3a8a',
          '950': '#172554'
        }
      }
    },
    borderColor: {
      'keyboard-focus': '#0a0a0a',
      positive: {
        DEFAULT: '#22c55e',
        disabled: '#bbf7d0'
      },
      critical: {
        DEFAULT: '#ef4444',
        disabled: '#fee2e2'
      },
      primary: '#d4d4d4',
      secondary: '#a3a3a3',
      info: {
        DEFAULT: '#3b82f6',
        disabled: '#bfdbfe'
      },
      caution: {
        DEFAULT: '#f97316',
        disabled: '#fed7aa'
      },
      brand: {
        DEFAULT: '#3d8f86',
        disabled: '#b0dfda',
        hover: '#2f726b',
        active: '#295c56'
      },
      tertiary: '#262626',
      support: {
        DEFAULT: '#262626',
        disabled: '#e5e5e5'
      },
      neutral: {
        hover: '#171717',
        DEFAULT: '#262626',
        disabled: '#e5e5e5',
        active: '#0a0a0a'
      },
      transparent: 'rgba(255, 255, 255, 0)',
      light: '#f5f5f5',
      inverse: '#ffffff',
      dark: '#d4d4d4'
    },
    ringColor: ({
      theme
    }) => Object.assign({}, theme('borderColor')),
    outlineColor: ({
      theme
    }) => Object.assign({}, theme('borderColor')),
    backgroundColor: {
      primary: '#ffffff',
      secondary: '#f5f5f5',
      tertiary: '#0a0a0a',
      transparent: 'rgba(255, 255, 255, 0)',
      critical: {
        light: '#fef2f2',
        dark: '#7f1d1d',
        DEFAULT: '#ef4444',
        hover: '#dc2626',
        active: '#b91c1c',
        disabled: '#fee2e2',
        soft: {
          DEFAULT: '#fef2f2',
          hover: '#fee2e2',
          active: '#fecaca',
          disabled: '#fef2f2'
        }
      },
      positive: {
        light: '#f0fdf4',
        dark: '#14532d',
        DEFAULT: '#22c55e',
        hover: '#16a34a',
        active: '#15803d',
        disabled: '#dcfce7',
        soft: {
          DEFAULT: '#f0fdf4',
          hover: '#dcfce7',
          active: '#bbf7d0',
          disabled: '#f0fdf4'
        }
      },
      caution: {
        dark: '#7c2d12',
        DEFAULT: '#f97316',
        hover: '#ea580c',
        active: '#c2410c',
        disabled: '#ffedd5',
        light: '#fff7ed',
        soft: {
          DEFAULT: '#ffedd5',
          hover: '#fed7aa',
          active: '#fdba74',
          disabled: '#fff7ed'
        }
      },
      info: {
        light: '#eff6ff',
        dark: '#1e3a8a',
        DEFAULT: '#3b82f6',
        hover: '#2563eb',
        active: '#1d4ed8',
        disabled: '#dbeafe',
        soft: {
          DEFAULT: '#dbeafe',
          hover: '#bfdbfe',
          active: '#93c5fd',
          disabled: '#eff6ff'
        }
      },
      brand: {
        dark: '#b0dfda',
        medium: '#d8efec',
        DEFAULT: '#3d8f86',
        hover: '#2f726b',
        active: '#295c56',
        disabled: '#b0dfda',
        soft: {
          DEFAULT: '#ffffff',
          hover: '#ffffff',
          active: '#f3faf9',
          disabled: '#ffffff'
        },
        light: '#f9fffe'
      },
      support: {
        DEFAULT: '#262626',
        hover: '#171717',
        active: '#0a0a0a',
        disabled: '#e5e5e5',
        light: '#fafafa',
        dark: '#f5f5f5',
        soft: {
          DEFAULT: '#fafafa',
          hover: '#e5e5e5',
          active: '#d4d4d4',
          disabled: '#fafafa'
        }
      },
      neutral: {
        DEFAULT: '#262626',
        hover: '#171717',
        active: '#0a0a0a',
        disabled: '#e5e5e5',
        soft: {
          DEFAULT: '#fafafa',
          hover: '#e5e5e5',
          active: '#d4d4d4',
          disabled: '#d4d4d4'
        }
      }
    },
    textColor: {
      primary: '#0a0a0a',
      secondary: '#525252',
      disabled: '#d4d4d4',
      inverse: '#ffffff',
      brand: {
        DEFAULT: '#3d8f86',
        foreground: '#ffffff',
        disabled: '#81c7bf'
      },
      critical: {
        DEFAULT: '#ef4444',
        foreground: '#ffffff',
        disabled: '#fca5a5',
        soft: {
          disabled: '#fca5a5'
        },
        hover: '#f87171'
      },
      positive: {
        DEFAULT: '#22c55e',
        foreground: '#ffffff',
        disabled: '#86efac'
      },
      caution: {
        DEFAULT: '#f97316',
        foreground: '#ffffff',
        disabled: '#fdba74'
      },
      info: {
        foreground: '#ffffff',
        disabled: '#93c5fd',
        DEFAULT: '#3b82f6'
      },
      support: {
        DEFAULT: '#0a0a0a',
        foreground: '#ffffff',
        disabled: '#a3a3a3',
        soft: {
          disabled: '#d4d4d4',
          foreground: '#0a0a0a'
        }
      },
      neutral: {
        DEFAULT: '#262626',
        foreground: '#ffffff',
        disabled: '#a3a3a3',
        soft: {
          foreground: '#262626',
          disabled: '#a3a3a3'
        }
      }
    },
    borderRadius: {
      none: '0',
      '2xs': '0.3125rem',
      xs: '0.5rem',
      sm: '0.625rem',
      md: '1.25rem',
      lg: '6.25rem',
      full: '624.9375rem'
    },
    spacing: Object.assign(Object.assign({}, defaultTheme.spacing), {
      none: '0',
      '2xs': '0.125rem',
      xs: '0.25rem',
      sm: '0.5rem',
      md: '0.75rem',
      lg: '1rem',
      xl: '1.5rem',
      '2xl': '2rem',
      '3xl': '2rem',
      '4xl': '3rem',
      '5xl': '4rem',
      '6xl': '6rem',
      '7xl': '12rem'
    }),
    boxShadow: {
      sm: '0px 4px 4px 0px #4b4b4d1a',
      md: '0px 2px 12px 0px #0000000f',
      lg: '0px 16px 48px 0px #4b4b4d33'
    },
    fontFamily: {
      primary: ['Inter', 'sans-serif'],
      secondary: ['Noto Sans', 'serif']
    },
    fontSize: {
      xs: '0.75rem',
      sm: '0.875rem',
      md: '1rem',
      lg: '1.125rem',
      xl: '1.25rem',
      '2xl': '1.5rem',
      '3xl': '2rem',
      '4xl': '2.8125rem',
      '5xl': '4rem',
      '6xl': '6rem'
    },
    fontWeight: {
      regular: '400',
      medium: '500',
      bold: '700',
      semibold: '600'
    },
    lineHeight: {
      xs: '0.875rem',
      sm: '1.25rem',
      md: '1.5rem',
      lg: '2rem',
      xl: '2.5rem',
      '2xl': '3.4375rem',
      '3xl': '4.625rem',
      '4xl': '7rem'
    },
    letterSpacing: {
      xs: '-0.09375em',
      sm: '-0.025em',
      md: '0',
      lg: '0.015em',
      xl: '0.0175em'
    },
    borderWidth: {
      none: '0px',
      sm: '1px',
      md: '2px',
      lg: '4px'
    }
  }
};
